import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Spin, message } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import axios from 'axios';
import './StatsCards.scss';
interface Stats {
    price: number;
    projects: number;
    capacity: number;
    production: number;
}
const fetchPriceStats = async () => {
    const res = await axios.get('/api/v1/prices/v2o5?limit=1');
    return res.data?.[0]?.price_cny || 0;
};
const fetchStorageStats = async () => {
    const res = await axios.get('/api/v1/storage/statistics?group_by=country');
    return {
        projects: res.data?.total_projects || 0,
        capacity: res.data?.total_capacity_mwh || 0
    };
};
const fetchProductionStats = async () => {
    const res = await axios.get('/api/v1/industry/production?limit=1');
    return res.data?.[0]?.production_tons || 0;
};
const StatsCards: React.FC = () => {
    const { data: price, isLoading: priceLoading, error: priceError, refetch: refetchPrice } = useQuery({
        queryKey: ['dashboard-price'],
        queryFn: fetchPriceStats,
        staleTime: 5 * 60 * 1000, 
        gcTime: 10 * 60 * 1000, 
        refetchInterval: 5 * 60 * 1000, 
        retry: 2
    });
    const { data: storage, isLoading: storageLoading, error: storageError, refetch: refetchStorage } = useQuery({
        queryKey: ['dashboard-storage'],
        queryFn: fetchStorageStats,
        staleTime: 10 * 60 * 1000, 
        gcTime: 30 * 60 * 1000,
        refetchInterval: 10 * 60 * 1000,
        retry: 2
    });
    const { data: production, isLoading: productionLoading, error: productionError, refetch: refetchProduction } = useQuery({
        queryKey: ['dashboard-production'],
        queryFn: fetchProductionStats,
        staleTime: 10 * 60 * 1000,
        gcTime: 30 * 60 * 1000,
        refetchInterval: 10 * 60 * 1000,
        retry: 2
    });
    const handleRefreshAll = () => {
        refetchPrice();
        refetchStorage();
        refetchProduction();
        message.success('正在刷新数据...');
    };
    const isLoading = priceLoading || storageLoading || productionLoading;
    const hasError = priceError || storageError || productionError;
    return (
        <div className="stats-overlay">
            <button
                className="refresh-button"
                onClick={handleRefreshAll}
                disabled={isLoading}
                title="刷新数据"
            >
                <ReloadOutlined spin={isLoading} />
            </button>
            <div className={`stat-card ${priceError ? 'error' : ''}`}>
                <div className="stat-label">V2O5价格</div>
                <div className="stat-value" style={{ whiteSpace: 'nowrap' }}>
                    {priceLoading ? (
                        <Spin size="small" />
                    ) : priceError ? (
                        <span className="error-text">加载失败</span>
                    ) : (
                        <>
                            {Math.round(price || 0).toLocaleString()} <span className="stat-unit" style={{ whiteSpace: 'nowrap' }}>元/吨</span>
                        </>
                    )}
                </div>
            </div>
            <div className={`stat-card ${storageError ? 'error' : ''}`}>
                <div className="stat-label">全球储能项目</div>
                <div className="stat-value">
                    {storageLoading ? (
                        <Spin size="small" />
                    ) : storageError ? (
                        <span className="error-text">加载失败</span>
                    ) : (
                        <>
                            {storage?.projects || 0} <span className="stat-unit">个</span>
                        </>
                    )}
                </div>
            </div>
            <div className={`stat-card ${storageError ? 'error' : ''}`}>
                <div className="stat-label">总装机容量</div>
                <div className="stat-value" style={{ whiteSpace: 'nowrap' }}>
                    {storageLoading ? (
                        <Spin size="small" />
                    ) : storageError ? (
                        <span className="error-text">加载失败</span>
                    ) : (
                        <>
                            {Math.round(storage?.capacity || 0).toLocaleString()} <span className="stat-unit" style={{ whiteSpace: 'nowrap' }}>MWh</span>
                        </>
                    )}
                </div>
            </div>
            <div className={`stat-card ${productionError ? 'error' : ''}`}>
                <div className="stat-label">年度产量</div>
                <div className="stat-value">
                    {productionLoading ? (
                        <Spin size="small" />
                    ) : productionError ? (
                        <span className="error-text">加载失败</span>
                    ) : (
                        <>
                            {(production || 0).toLocaleString()} <span className="stat-unit">吨</span>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};
export default StatsCards;
